import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'
import Menu from './Menu';

class Header extends React.Component {	
    constructor(props){
        super(props);
        this.handleClick    = this.handleClick.bind(this);
    }

    componentDidMount(){
        let {menu}              = this.props;
        window.addEventListener( "pageshow", function ( event ) {
            var historyTraversal = event.persisted || 
                                   ( typeof window.performance != "undefined" && 
                                        window.performance.navigation.type === 2 );
            if ( historyTraversal ) {
              // Handle page restore.
              window.location.reload();
            }
        });
    }

    handleClick = () => {
        
    }

    render() {
        let {options}   = this.props.options;
        let {menu}      = this.props.menu;
        let logoStyle   = this.props.noLogo ? {visibility:'hidden'} : {};
        let bgColor     = this.props.bgColor ? {backgroundColor:this.props.bgColor} : {};
        let headerTheme     = this.props.headerTheme ? this.props.headerTheme : '';
        return (
            <header style={bgColor} className={headerTheme}>
                <div className="main-container">
                    <Link to={`${process.env.PUBLIC_URL}/`} className="ll-logo" style={logoStyle}>
                        <img src={options.logo_image} alt="Le Lay Architects" title="Le Lay Architects"/>
                    </Link>
                    <a href="javascript:" className="btn-hammenu toggle-menu"></a>
                </div>
            </header>

        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js